export default __webpack_public_path__ + "static/media/GEPEFFS_USP.c258615d.png";